import { render, staticRenderFns } from "./table.vue?vue&type=template&id=198f8e96&lang=html"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"
import style0 from "./table.vue?vue&type=style&index=0&id=198f8e96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./table.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TutorialAlert: require('/app/ui/public/components/tutorial/tutorial-alert.vue').default,DatasetNbResults: require('/app/ui/public/components/dataset/dataset-nb-results.vue').default,DatasetFilters: require('/app/ui/public/components/dataset/dataset-filters.vue').default,DatasetSelectCols: require('/app/ui/public/components/dataset/dataset-select-cols.vue').default,DatasetDownloadResults: require('/app/ui/public/components/dataset/dataset-download-results.vue').default,DatasetTableHeaderCell: require('/app/ui/public/components/dataset/dataset-table-header-cell.vue').default,DatasetTableHeaderMenu: require('/app/ui/public/components/dataset/dataset-table-header-menu.vue').default,DatasetTableCell: require('/app/ui/public/components/dataset/dataset-table-cell.vue').default,DatasetTableDragCol: require('/app/ui/public/components/dataset/dataset-table-drag-col.vue').default,LayoutScrollToTop: require('/app/ui/public/components/layout/layout-scroll-to-top.vue').default,DatasetItemCard: require('/app/ui/public/components/dataset/dataset-item-card.vue').default})
